import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES } from "../types";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";
import {
  setNoEntriesMessageMultipleSearch,
  getWatchListMultipleSearchEntriesPending,
  getWatchListMultipleSearchEntriesFulfilled,
  getWatchListMultipleSearchEntriesRejected,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { watchListMultipleSearchEntriesFiltersSelector } from "../selectors";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "watchlistentry/searchfromfile",
  onSuccess: [
    getWatchListMultipleSearchEntriesFulfilled,
    (response) =>
      response.data.length === 0
        ? setNoEntriesMessageMultipleSearch(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
        : { type: "" },
  ],
  onError: [
    getWatchListMultipleSearchEntriesRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "formDataApi",
};

const getWatchListMultipleSearchEntriesEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = watchListMultipleSearchEntriesFiltersSelector(
        state$.value
      );

      return merge(
        of(getWatchListMultipleSearchEntriesPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getWatchListMultipleSearchEntriesEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListMultipleSearchEntriesEpic.js